/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedMakeOfferButton_item = {
    readonly serviceId: string | null;
    readonly makeOfferVpvParams?: unknown | null | undefined;
    readonly contemporaryTrackingString: string;
    readonly title: string | null;
    readonly seller: {
        readonly serviceId: string | null;
    } | null;
    readonly pricing: {
        readonly totalAmount: {
            readonly amount: number | null;
        } | null;
    } | null;
    readonly categoryCode: string | null;
    readonly browseUrl: string | null;
    readonly isPrivateVisibilityType: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"SharedContactDealerWrapper_item">;
    readonly " $refType": "PdpSharedMakeOfferButton_item";
};
export type PdpSharedMakeOfferButton_item$data = PdpSharedMakeOfferButton_item;
export type PdpSharedMakeOfferButton_item$key = {
    readonly " $data"?: PdpSharedMakeOfferButton_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedMakeOfferButton_item">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isClient"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedMakeOfferButton_item",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contemporaryTrackingString",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemPricing",
      "kind": "LinkedField",
      "name": "pricing",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "kind": "LinkedField",
          "name": "totalAmount",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "amount",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "categoryCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "browseUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPrivateVisibilityType",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_item"
    },
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "makeOfferVpvParams",
          "args": [
            {
              "kind": "Literal",
              "name": "excludedPurchaseStatuses",
              "value": [
                "RET",
                "CUST"
              ]
            },
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "kind": "ScalarField",
          "name": "pdpTrackingVpvParams",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();
(node as any).hash = 'dfd62835b02728c281f78b1e5935cd41';
export default node;
